import { on } from '@ember/modifier';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import perform from 'ember-concurrency/helpers/perform';
import t from 'ember-intl/helpers/t';

import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import Window from 'umg-ember-backend/components/ui/window';

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:title>
      {{t 'tool_merge_artists.headline'}}
    </:title>

    <:body>
      <Form
        @disableRegisterToBreadcrumb={{true}}
        @model={{@controller.mergeArtistSettings}}
        as |form|
      >
        <div class='o-layout'>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            <form.fieldset @titleKey='settings' as |fieldset|>
              <fieldset.field
                @property='target'
                @isSearchEnabled={{true}}
                @onSearch={{perform @controller.searchArtists}}
                @type='select-record'
              />

              <fieldset.field
                @property='sources'
                @type='select-multiple'
                @isSearchEnabled={{true}}
                @onSearch={{perform @controller.searchArtists}}
                @labelProperty='displayLabel'
                @selected={{@controller.mergeArtistSettings.sources}}
                @onChange={{@controller.onChangeSources}}
              />

              <Button
                @disabled={{@controller.notReady}}
                @label={{t 'tool_merge_artists.merge'}}
                @icon='merge'
                {{on 'click' (perform @controller.mergeArtists)}}
              />
            </form.fieldset>
          </div>
          <div class='o-layout__item u-1/1 u-1/2@tablet'></div>
        </div>
      </Form>
    </:body>
  </Window>
</template>
